import { render, staticRenderFns } from "./OListPaging.vue?vue&type=template&id=30a81efb&scoped=true&"
import script from "./OListPaging.vue?vue&type=script&lang=js&"
export * from "./OListPaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a81efb",
  null
  
)

export default component.exports